import AddIcon from '@material-ui/icons/Add';
import DefaultIconButton from '../../../../@common/components/forms/DefaultIconButton';
import useProductModal from '../../../store/hooks/useProductModal';

export default ({ text }: any) => {
  const { openProductModal } = useProductModal();
  return <DefaultIconButton onClick={openProductModal} startIcon={<AddIcon />} text={text} />;
};
